(() => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const imageCache = new Map();

  const finishImageSwap = (stage, source, overlay) => {
    const nextImage = stage.querySelector('.jm-mfp-img:not(.judgeme-gallery-swap-image)');
    if (!nextImage || nextImage.getAttribute('src') !== source) return false;
    if (!nextImage.complete) {
      if (!nextImage.dataset.judgemeSwapLoadBound) {
        nextImage.dataset.judgemeSwapLoadBound = 'true';
        nextImage.addEventListener('load', () => finishImageSwap(stage, source, overlay), { once: true });
      }
      return false;
    }

    requestAnimationFrame(() => {
      overlay.classList.add('judgeme-gallery-swap-image--leaving');
      overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
      window.setTimeout(() => overlay.remove(), 300);
    });
    return true;
  };

  const prepareImageSwap = (thumbnail) => {
    const source = thumbnail.querySelector('img[data-mfp-src]')?.dataset.mfpSrc;
    const main = thumbnail.closest('.jm-mfp-main');
    const stage = main?.querySelector('.jm-mfp-content-wrapper');
    const currentImage = stage?.querySelector('.jm-mfp-img');
    if (!source || !stage || !currentImage) return;

    stage.querySelector('.judgeme-gallery-swap-image')?.remove();
    const overlay = currentImage.cloneNode(false);
    overlay.removeAttribute('style');
    overlay.className = 'jm-mfp-img judgeme-gallery-swap-image';
    stage.appendChild(overlay);

    const swapObserver = new MutationObserver(() => {
      if (!finishImageSwap(stage, source, overlay)) return;
      swapObserver.disconnect();
    });
    swapObserver.observe(stage, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

    window.setTimeout(() => {
      swapObserver.disconnect();
      overlay.classList.add('judgeme-gallery-swap-image--leaving');
      window.setTimeout(() => overlay.remove(), 250);
    }, 1500);
  };

  const preloadGallery = (root = document) => {
    root.querySelectorAll?.('.jm-mfp-carousel img[data-mfp-src]').forEach((thumbnail) => {
      const source = thumbnail.dataset.mfpSrc;
      if (!source || imageCache.has(source)) return;

      const image = new Image();
      image.decoding = 'async';
      image.src = source;
      imageCache.set(source, image);
    });
  };

  const scheduleGalleryPreload = () => {
    [0, 100, 300].forEach((delay) => window.setTimeout(() => preloadGallery(), delay));
  };

  document.addEventListener(
    'click',
    (event) => {
      const thumbnail = event.target.closest('.jm-mfp-carousel .jdgm-gallery__thumbnail-link');
      if (!thumbnail) {
        if (event.target.closest('.jdgm-gallery__thumbnail-link, .jdgm-rev__pic-link')) {
          scheduleGalleryPreload();
        }
        return;
      }

      const currentThumbnail = event.target.closest(
        '.jm-mfp-carousel .jdgm-gallery__thumbnail-link--current'
      );

      if (!currentThumbnail) {
        prepareImageSwap(thumbnail);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  preloadGallery();
})();